import React from 'react'
import { AppImg, AppSvg, FormattedHTMLMessage, icons, Button } from '@web/walter-ui-kit'
import { useAuth } from '@web/walter-lib/auth'

import { useIntl } from 'react-intl'
import styles from '../../style.module.css'
import { lang } from './lang'
import ModalView from '~components/ModalView'
import { images } from '~constants/images'
import { globalLang } from '~globalLang'

interface Props {
    onNext: () => void
    isTokenLoading: boolean
}

function Start({ onNext, isTokenLoading }: Props) {
    const intl = useIntl()
    const brokerName = intl.formatMessage(globalLang.brokerName)

    const { logout, isLogoutLoading } = useAuth()

    return (
        <ModalView
            img={
                <div className={styles.imageGroup}>
                    <div className={styles.logoFreewallet}>
                        <AppImg themed imgName={images.logoFreewallet} />
                    </div>
                    <div className={styles.arrowSvg}>
                        <AppSvg size={30} svgName={icons.ic24ArrowRight} />
                    </div>
                    <AppImg size={60} themed imgName={images.logoSquare} />
                </div>
            }
            title={<FormattedHTMLMessage {...lang.startMigrationTitle} />}
            subtitle={<FormattedHTMLMessage {...lang.startMigrationSubtitle} values={{ brokerName }} />}
        >
            <div className={styles.mainActionButton}>
                <Button
                    size="l"
                    fullWidth
                    mode="primary"
                    onClick={onNext}
                    isLoading={isTokenLoading}
                    isDisabled={isLogoutLoading}
                    dataPointer="start_migration_button"
                >
                    <FormattedHTMLMessage {...lang.startMigrationButtonText} />
                </Button>
            </div>
            <Button
                size="l"
                fullWidth
                onClick={() => logout()}
                isDisabled={isTokenLoading}
                isLoading={isLogoutLoading}
                dataPointer="logout_button"
            >
                <FormattedHTMLMessage {...lang.signOutButtonText} />
            </Button>
        </ModalView>
    )
}

export default Start
